import React from "react";
import ControlSection from "./ControlSection";

/**
 * Stroke size control component
 */
const StrokeSizeControl = ({
  value,
  min,
  max,
  onChange,
  onBlur,
  onKeyDown,
}) => {
  return (
    <ControlSection>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <label style={{ whiteSpace: "nowrap" }}>Stroke Size</label>
        <input
          type="number"
          min={min}
          max={max}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          style={{
            width: "100%",
            padding: "4px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "#fff",
          }}
        />
      </div>
    </ControlSection>
  );
};

export default StrokeSizeControl;
